import { useTranslation } from 'react-i18next'

import { useModal } from '@context/ModalsContext'

import { Button } from '@ui/components/Button/Button'
import { TableNoResults } from '@ui/v2/Table/Table'

import { useWindowResize } from '@utils/domUtils'

import { Box } from '@shared/components/Box'

import { AddInstrumentsModal } from './Modals/AddInstrumentsModal'

interface WatchlistEmptyStateProps {
  watchlistName?: string
  accountCode?: string
  ownerExternalId?: string
  favoriteSymbols?: string[]
  watchlistId?: number
  onAddInstruments?: () => void
}

export const WatchlistEmptyState: React.FC<WatchlistEmptyStateProps> = ({
  onAddInstruments,
  watchlistName,
  accountCode,
  ownerExternalId,
  favoriteSymbols,
  watchlistId,
}) => {
  const { t } = useTranslation()
  const isMobile = useWindowResize()
  const addInstrumentsModal = useModal(AddInstrumentsModal)

  const handleAddInstruments = () => {
    onAddInstruments?.()
    addInstrumentsModal.open({
      watchlistName,
      accountCode,
      ownerExternalId,
      favoriteSymbols,
      watchlistId,
    })
  }

  return (
    <Box px={isMobile ? 'x0' : 'x16'} fullWidth>
      <TableNoResults
        title={t('Instruments.No instruments in your watchlist')}
        content={
          <Box minWidth='200px'>
            <Button.Primary size='md' onClick={handleAddInstruments} fullWidth>
              {t('Instruments.Add instruments')}
            </Button.Primary>
          </Box>
        }
      />
    </Box>
  )
}
